import { Component } from '@angular/core';
import { UserService } from '../../services/user.service';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

/**
 * Renders a geographic feature toolset grid cell.
 */
@Component({
  selector: 'grid-geo-feature-tools-cell-renderer',
  templateUrl: './grid-geo-feature-tools-cell-renderer.component.html',
  styleUrl: './grid-geo-feature-tools-cell-renderer.component.css'
})
export class GridGeoFeatureToolsCellRendererComponent implements ICellRendererAngularComp {
	LOCALIZATION: any;
	userPermissions: { [key: string]: any } = {};

	context: any; // Passed in through the parent gridOptions 
	record: any;

	constructor(
		private userService: UserService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.userPermissions = this.userService.getUserPermissionsMap();
	}

	agInit(params: ICellRendererParams): void {
		this.refresh(params);
	}

	refresh(params: ICellRendererParams): boolean {
		this.record = params?.data || {};

		this.context = params.context;

		return true;
	}

	zoomToFeature(event?: Event): void {
		if (event) event.stopPropagation();
		this.context.zoomToFeature(this.record);
	}
}